import { RootAppState } from 'store/configureStore'

export const projectSalesRepresentativeSelector = (state: RootAppState) =>
  state.project.activeProject?.salesPerson
